<template>
  <div class="mt-8">
    <lazy-landing-page-modview-wrapper
      v-if="component.customComponent.componentKey === 'minecraftModPack'"
      :title="component.customComponent.title"
      class="max-w-screen-xl mx-auto px-4"
    />

    <!-- TODO: Delete after migrate to the generic banner component -->
    <lazy-landing-page-modspace-banner
      v-else-if="
        component.customComponent.componentKey === 'farmingSimModSpace'
      "
      :order-url="orderUrl"
      :component="component"
      class="max-w-screen-xl mx-auto px-4"
    />

    <!-- TODO: Delete after migrate to the generic banner component -->
    <!-- TODO: Remove order-url from StrapiHomePageComponents ans StrapiProductComponents -->
    <lazy-landing-page-banner
      v-else-if="component.customComponent.componentKey != null"
      :order-url="orderUrl"
      :component="component"
      class="max-w-screen-xl mx-auto px-4"
    />
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

defineProps({
  orderUrl: {
    type: String,
    required: false,
    default: null,
  },
  component: {
    type: Object as PropType<StrapiCustomComponent>,
    required: true,
  },
});
</script>

<style scoped></style>
